import Catalog from 'blocks.app/catalog/catalog'
import Content from 'blocks.app/content/content'
import Sidebar from 'blocks.app/sidebar/sidebar'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import { updateURLProtocol } from 'core/utils/convertUtil'
import React, { useEffect, useRef, useState } from 'react'
import styles from './UploadLogsTasks.jcss'
import { cn } from 'ethcss'
import { grid } from 'theme'
import Button from 'blocks.simple/button/button'
import { MenuItem } from '../displays/__toolbarContent/displays__toolbarContent'
import { SidebarMultiselectMenu } from '../../blocks.app/sidebarMultiselectMenu/SidebarMultiselectMenu'
import { Tooltip } from 'atoms/Tooltip'

interface SelectedInfo {
    fileURL: string
    id: number
    digitalSignage: {
        name: string
    }
}

const UploadLogTasks = () => {
    const [selectedItems, setSelectedItems] = useState<SelectedInfo[]>([])
    const [selectedInfo, setSelectedInfo] = useState<any>(null)
    const deleteItemRef = useRef<any>(null)
    const downloadItemRef = useRef<any>(null)
    const [limitExceeded, setLimitExceeded] = useState(false)

    useEffect(() => {
        setLimitExceeded(selectedItems.length > window.spconfig.logDownloadRateLimit)
    }, [selectedItems])

    const deleteUploadLogs = async () => {
        const taskIds = selectedItems.map((item) => item.id)

        api.send('deleteUploadLogTasks', { taskIds }).then(() => {})
    }

    const downloadUploadLogs = async () => {
        for (const item of selectedItems) {
            if (item.fileURL) {
                try {
                    const updatedUrl = updateURLProtocol(item.fileURL)

                    const response = await fetch(updatedUrl)
                    const blob = await response.blob()

                    const fileName = updatedUrl.split('/').pop()?.split('?')[0] || 'file'

                    const blobUrl = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = blobUrl
                    link.download = fileName
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    window.URL.revokeObjectURL(blobUrl)

                    await new Promise((resolve) => setTimeout(resolve, 300))
                } catch (error) {
                    console.error(`Ошибка при скачивании ${item.fileURL}:`, error)
                }
            }
        }
    }

    const renderTopContent = () => {
        return (
            <div>
                <SidebarMultiselectMenu>
                    <Tooltip title={translate('logDownloadRateLimitExceeded')} isEnabled={limitExceeded}>
                        <MenuItem
                            data={{ name: 'download' }}
                            onClick={() => {
                                downloadItemRef.current()
                            }}
                            forceDisable={limitExceeded}
                        />
                    </Tooltip>
                    <MenuItem
                        data={{ name: 'delete' }}
                        onClick={() => {
                            deleteItemRef.current()
                        }}
                    />
                </SidebarMultiselectMenu>
            </div>
        )
    }
    const renderSelectedInfoContent = () => {
        return (
            <div>
                <div className={cn(grid.p_md, styles.buttons)}>
                    {selectedInfo && selectedInfo.status !== 'done' && selectedInfo.status !== 'canceled' && (
                        <Button
                            onClick={() => {
                                api.send('cancelUploadTask', { taskIds: [selectedInfo.id] }).then(() => {})
                            }}
                            mod={'clear'}
                        >
                            {translate('cancelUpload')}
                        </Button>
                    )}
                    {selectedInfo && selectedInfo.status === 'done' && (
                        <Button
                            onClick={() => {
                                if (selectedInfo.fileURL) {
                                    let link = document.createElement('a')
                                    const updatedUrl = updateURLProtocol(selectedInfo.fileURL)
                                    link.href = updatedUrl
                                    link.click()
                                }
                            }}
                            mod={'clear'}
                        >
                            {translate('download')}
                        </Button>
                    )}
                    {selectedInfo && (selectedInfo.status === 'done' || selectedInfo.status === 'canceled') && (
                        <Button
                            onClick={() => {
                                api.send('deleteUploadLogTasks', { taskIds: [selectedInfo.id] }).then(() => {})
                            }}
                            mod={'clear'}
                        >
                            {translate('delete')}
                        </Button>
                    )}
                </div>
            </div>
        )
    }

    return (
        <Content
            title={translate('uploadLogTasks')}
            toolbar={
                <Sidebar
                    customHeader={
                        <>
                            <div className={styles.sidebarHeader}>{translate('uploadLogTasks')}</div>
                        </>
                    }
                    selectedSide={'right'}
                    isEmpty={{
                        right: !selectedItems.length && !selectedInfo,
                    }}
                    emptyText={{
                        right: {
                            title: translate('noSelectedUploadLogs'),
                            description: translate('noSelectedUploadLogDescription'),
                        },
                    }}
                    content={{
                        right:
                            !selectedInfo && selectedItems.length
                                ? {
                                      title: `${translate('countOfSelectedUploadLogs')} ${
                                          selectedItems ? selectedItems.length : ''
                                      }`,
                                      options: selectedItems.map((item) => {
                                          return {
                                              ...item,
                                              name: item?.digitalSignage?.name,
                                          }
                                      }),
                                  }
                                : selectedInfo
                                ? {
                                      title: (
                                          <div className={styles.title}>
                                              {translate('device')} {selectedInfo?.digitalSignage?.name}
                                          </div>
                                      ),
                                      options: [],
                                  }
                                : null,
                    }}
                    isDownloadable={selectedItems.every((item) => !!item.fileURL)}
                    isDeletable
                    isShowActions={false}
                    onSubmit={(side: string, type: string) => {
                        if (side === 'right' && type === 'delete') {
                            deleteUploadLogs()
                        } else if (side === 'right' && type === 'download') {
                            downloadUploadLogs()
                        }
                    }}
                    topContent={{
                        right: selectedItems.length ? renderTopContent() : null,
                    }}
                    onChange={(e) => {
                        setSelectedItems(e)
                    }}
                    customContent={{
                        right: renderSelectedInfoContent(),
                    }}
                    deleteItemRef={deleteItemRef}
                    downloadItemRef={downloadItemRef}
                />
            }
        >
            <Catalog
                type="uploadLogTasks"
                onSelectInfo={(selectedInfo: SelectedInfo) => {
                    if (!selectedInfo) return
                    setSelectedInfo(selectedInfo)
                    //setSelectedItems([selectedInfo])
                }}
                onSelect={(a: any) => {
                    setSelectedItems(a)
                    setSelectedInfo(null)
                }}
                selectedItems={selectedItems}
                hideHeader={true}
                selectAllCheckbox={true}
                treeView={false}
                selectedInfo={selectedInfo}
            />
        </Content>
    )
}

export default UploadLogTasks
